const Theme = {
  body_background_color: '#00599A',
  logo_image_url: 'sciencenorth.png',
  logo_height: 100,

  button_color: '#00599A',
  button_text_uppercase: true,
  button_outlined_as_default: true,
  button_half_border_color: '#00599A',

  text_font: `'CrimsonText', serif`,
  title_font: `'OpenSans', sans-serif`,
}

export default Theme
